<template>
  <div :style="{'--dropdownMenuWidth':dropdownMenuWidth, '--dropdownMenuLeft': dropdownMenuLeft}">


    <van-dropdown-menu class="flex-1" ref="dropdownMenu" id="dropdownMenu" v-if="placeHolder === 'Date'">
      <van-dropdown-item ref="dropdownItem" :value="value">
        <template #title>
          <div class="text-14px" :class="ingredientTextClass">
            {{ ingredientText }}
          </div>
        </template>

        <template>
          <div class="dropdown-menu-date flex flex-col">
            <div class="flex flex-row items-center justify-between" style="font-weight: bold; font-size:24px">
              <div class="horizontal items-center ">
                <DropdownDateHistory :options="monthActions" :active="changeMonth" :value="currentMonth"
                    @input="onSelectMonth" @onshow="onShowMonth"/>
                <DropdownDateHistory class="ml-3" :options="yearActions" :active="!changeMonth"
                    :value="currentYear"
                    @input="onSelectYear" @onshow="onShowYear"/>

                <!--          <span @click="toggleDate(true)" style="width:80px"-->
                <!--              :class="changeMonth? 'main-color':'third-color' ">{{ currentMonthAbbreviations }}</span>-->
                <!--          <span @click="toggleDate(false)" class="year "-->
                <!--              :class="changeMonth? 'third-color': 'main-color'">{{ currentYear }}</span>-->

              </div>
              <div>
                <span @click="onClickPrevMonth"><</span>
                <span style="margin-left:32px" :class="disabledNextMonth ? 'disable-next-month':''"
                    @click="onClickNextMonth">></span>
              </div>
            </div>

            <div class="weekend" id="dropdown-menu-container">
              <span style="width:30px" v-for="(item,index) in weekend" :key="index">{{ item }}</span>
            </div>
            <div class="grid grid-cols-7 text-center gap-3 mt-2.5" style="height:240px">
              <span v-for="(item,index) in dayOfMonth" :key="currentMonth + index"
                  :class="[item.active?'day-active' :'day', item.selected ? 'day-select': '']"
                  @click="onDayClick(item,index)">{{ item.day }}</span>
            </div>

            <div class="flex flex-row center-items justify-around mt-4 w-full">
              <div class="cancel-btn radius-border" @click="onCancel">Cancel</div>
              <div class="apply-btn" @click="onApply">Apply</div>
            </div>
          </div>
        </template>

      </van-dropdown-item>
    </van-dropdown-menu>

    <van-dropdown-menu class="flex-1" style="overflow: hidden; text-overflow: ellipsis" ref="dropdownMenu" v-else>
      <van-dropdown-item ref="dropdownItem" :value="value">
        <template #title>
          <div style="overflow: hidden; text-overflow: ellipsis" class="text-14px" :class="ingredientTextClass">
            {{ placeHolder }}
          </div>
        </template>

        <template>
          <div class="dropdown-menu-custom">
            <div @click="onInput(index,item)" class="p-1 text-14px" style="overflow: hidden;text-overflow: ellipsis"
                v-for="(item,index) in options"
                :key="index" :class="item.text === ingredientText ? 'active-color': ''"><span> {{ item.text }}</span>
            </div>
          </div>
        </template>

      </van-dropdown-item>

    </van-dropdown-menu>
  </div>
</template>
<script>
import log from "@/util/log";
import DropdownDate from "@/components/DropdownDate.vue";
import DropdownDateHistory from "@/components/DropdownDateHistory.vue";

export default {
  name: "DropdownFilter",
  components: { DropdownDateHistory, DropdownDate },
  props: {
    value: [Number, String],
    placeHolder: "",
    options: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      test: 0,
      dropdownMenuWidth: 0,
      dropdownMenuLeft: 0,
      weekend: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      monthActions: [
        { text: "Jan", value: 1, active: true },
        { text: "Feb", value: 2, active: true },
        { text: "Mar", value: 3, active: true },
        { text: "Apr", value: 4, active: true },
        { text: "May", value: 5, active: true },
        { text: "Jun", value: 6, active: true },
        { text: "Jul", value: 7, active: true },
        { text: "Aug", value: 8, active: true },
        { text: "Sep", value: 9, active: true },
        { text: "Oct", value: 10, active: true },
        { text: "Nov", value: 11, active: true },
        { text: "Dec", value: 12, active: true }
      ],
      yearActions: (() => {
        const today = new Date()
        const year = today.getFullYear()
        const years = []
        for (let i = 2022; i <= year; i++) {
          years.push({ text: `${i}`, value: i, active: true })
        }
        return years;
      })(),
      currentMonth: "",
      currentYear: "",
      dayOfMonth: null,

      prevSelectIndex: -1,
      disabledNextMonth: true,

      changeMonth: true,

    };
  },
  methods: {
    checkMonth() {
      const today = new Date()
      const month = today.getMonth()
      console.log(month)
      if (this.currentYear === today.getFullYear()) {
        this.monthActions.forEach((item, index) => {
          if (index <= month) {
            item.active = true
          } else {
            item.active = false
          }
        })
      } else {
        this.monthActions = [
          { text: "Jan", value: 1, active: true },
          { text: "Feb", value: 2, active: true },
          { text: "Mar", value: 3, active: true },
          { text: "Apr", value: 4, active: true },
          { text: "May", value: 5, active: true },
          { text: "Jun", value: 6, active: true },
          { text: "Jul", value: 7, active: true },
          { text: "Aug", value: 8, active: true },
          { text: "Sep", value: 9, active: true },
          { text: "Oct", value: 10, active: true },
          { text: "Nov", value: 11, active: true },
          { text: "Dec", value: 12, active: true }
        ]
      }
    },
    onShowMonth() {
      this.changeMonth = true
      this.checkMonth()
    },
    onShowYear() {
      this.changeMonth = false
    },
    onSelectMonth(e, index) {
      console.log(e, index);
      this.currentMonth = e.value


      const nextDate = new Date(this.currentYear, this.currentMonth - 1);
      const currentDate = new Date();
      console.log(nextDate);
      if (nextDate > currentDate) {
        console.log(`超过了`);
        this.currentMonth = currentDate.getMonth() + 1;
      }
      this.dayOfMonth = this.generateDayOfMonth(this.currentYear, this.currentMonth);
    },
    onSelectYear(e, index) {
      console.log(e, index);
      this.currentYear = e.value

      const nextDate = new Date(this.currentYear, this.currentMonth - 1);
      const currentDate = new Date();
      console.log(nextDate);
      if (nextDate > currentDate) {
        console.log(`超过了`);
        this.currentMonth = currentDate.getMonth() + 1;
      }
      this.dayOfMonth = this.generateDayOfMonth(this.currentYear, this.currentMonth);
    },
    toggleDate(isMonth) {
      this.changeMonth = isMonth
    },
    generateDayOfMonth(currentYear, currentMonth) {
      //接下来，我们需要确定当前月份有多少天，这可以通过创建下一个月的第0天来实现：
      const daysInMonth = new Date(currentYear, currentMonth, 0).getDate();
      // 获取当前月份的第一天是星期几
      const firstDayOfWeek = new Date(currentYear, currentMonth - 1, 1).getDay(); // JavaScript 中星期天是0
      // 生成当前月份的日期数组
      const dates = [];

      // 补全上个月的日期
      const lastMonth = currentMonth === 1 ? 12 : currentMonth - 1;
      const lastYear = currentMonth === 1 ? currentYear - 1 : currentYear;
      const daysInLastMonth = new Date(lastYear, lastMonth, 0).getDate();

      for (let i = firstDayOfWeek - 1; i >= 0; i--) {
        dates.push({
          year: lastYear,
          month: lastMonth,
          day: daysInLastMonth - i
        });
      }

      // 添加当前月份的日期
      for (let i = 1; i <= daysInMonth; i++) {
        const findIndex = this.options.findIndex(item => item.createTime === `${currentYear}-${this.formatNumberToTwoDigits(currentMonth)}-${this.formatNumberToTwoDigits(i)}`);

        dates.push({
          year: currentYear,
          month: currentMonth,
          day: i,
          active: findIndex !== -1,
          selected: false
        });
      }

      // 补全下个月的日期
      const nextMonth = currentMonth === 12 ? 1 : currentMonth + 1;
      const nextYear = currentMonth === 12 ? currentYear + 1 : currentYear;
      const daysInNextMonth = 7 - (dates.length % 7);

      for (let i = 1; i <= daysInNextMonth; i++) {
        dates.push({
          year: nextYear,
          month: nextMonth,
          day: i
        });
      }
      return dates;
    },
    onDayClick(item, index) {
      if (!item.active) {
        return;
      }
      if (this.prevSelectIndex !== -1) {
        this.dayOfMonth[this.prevSelectIndex].selected = false;
      }
      if (this.prevSelectIndex === index) {
        this.prevSelectIndex = -1;
        this.dayOfMonth[index].selected = false;
        return;
      }
      this.prevSelectIndex = index;
      this.dayOfMonth[index].selected = true;
    },
    onClickPrevMonth() {
      this.prevSelectIndex = -1;

      if (this.changeMonth) {
        this.currentMonth -= 1;
        if (this.currentMonth < 1) {
          this.currentMonth = 12;
          this.currentYear -= 1;
        }
      } else {
        this.currentYear -= 1
      }


      this.dayOfMonth = this.generateDayOfMonth(this.currentYear, this.currentMonth);
      this.disabledNextMonth = false;
    },
    onClickNextMonth() {
      this.prevSelectIndex = -1;
      if (this.disabledNextMonth) {
        return;
      }

      if (this.changeMonth) {
        this.currentMonth += 1;
        if (this.currentMonth > 12) {
          this.currentMonth = 1;
          this.currentYear += 1;
        }
      } else {
        this.currentYear += 1
        const nextDate = new Date(this.currentYear, this.currentMonth - 1)
        const currentDate = new Date()
        console.log(nextDate)
        if (nextDate > currentDate) {
          console.log(`超过了`)
          this.currentMonth = currentDate.getMonth() + 1
        }

      }
      this.dayOfMonth = this.generateDayOfMonth(this.currentYear, this.currentMonth);

      const currentDate = new Date();
      currentDate.setDate(1);
      currentDate.setHours(0);
      currentDate.setMinutes(0);
      currentDate.setMinutes(0);
      if (new Date(this.currentYear, this.currentMonth, 1, 0, 0, 0) > currentDate) {
        this.disabledNextMonth = true;
      }
    },
    onInput(index, e) {
      if (e.text === this.ingredientText) {
        this.$emit("input", "", { text: "", value: "" });
        this.$refs.dropdownItem.toggle();
        return;
      }
      this.$refs.dropdownItem.toggle();
      log(e);
      this.$emit("input", index, e);
    },
    formatNumberToTwoDigits(number) {
      return number < 10 ? "0" + number : "" + number;
    },
    onCancel() {
      this.$emit("onCancel");
      this.$refs.dropdownItem.toggle(false);
    },
    onApply() {
      const findSelected = this.dayOfMonth.filter(item => item.selected);
      if (findSelected.length === 0) {
        this.$emit("onApply", "");
        this.$refs.dropdownItem.toggle(false);
        return;
      }
      this.$emit("onApply", findSelected[0]);
      this.$refs.dropdownItem.toggle(false);
    }
  },
  computed: {

    currentMonthAbbreviations() {
      return this.monthsAbbreviations[this.currentMonth - 1];
    },

    ingredientText() {
      if (this.placeHolder === "Date") {
        return this.placeHolder;
      }
      if (this.value === "") {
        return this.placeHolder;
      }
      const text = this.options[this.value].text;
      if (text === "") {
        return this.placeHolder;
      }
      return text;
    },
    ingredientTextClass() {
      if (this.value === "") {
        return "main-color";
      }
      return "";
    }
  },

  mounted() {
    this.$nextTick(() => {
      const el = this.$refs.dropdownMenu.$el;
      const clientWidth = el.clientWidth;
      const offsetLeft = el.offsetLeft;
      if (this.placeHolder === "Date") {
        this.dropdownMenuWidth = `${document.body.clientWidth - 32 * 2}px`;
        this.dropdownMenuLeft = `32px`;
      } else {
        this.dropdownMenuWidth = `${clientWidth + 50}px`;
        let left = offsetLeft + 16 - 25;
        if (left + clientWidth + 50 > document.body.clientWidth) {
          left = document.body.clientWidth - (clientWidth + 50) - 16;
        }
        this.dropdownMenuLeft = `${left > 0 ? left : 16}px`;
      }
      log(`dropdownMenu = ${clientWidth}`);
    });

    if (this.placeHolder == "Date") {
      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth() + 1; // JavaScript 中月份从0开始，所以要加1
      if (!this.dayOfMonth) {
        this.dayOfMonth = this.generateDayOfMonth(currentYear, currentMonth);
        this.currentYear = currentYear;
        this.currentMonth = currentMonth;
      }

    }
  }
};
</script>


<style scoped lang="less">
::v-deep .van-dropdown-menu {
  border: none;

  .van-dropdown-menu__bar {
    background: transparent;
    box-shadow: none;
  }

  .van-dropdown-menu__title {
    //flex: 1;
  }

  .van-dropdown-menu__title::after {
    margin-top: -4px;
    border: 4px solid;
    border-color: transparent transparent #333333 #333333;
  }

  .van-dropdown-menu__title--active {
    color: #333333;
  }

  .van-popup--top {
    width: var(--dropdownMenuWidth);
    left: var(--dropdownMenuLeft);
    overflow: hidden;
  }

  .van-overlay {
    background-color: transparent;
  }

  .van-cell__title {
    text-align: center;
  }

  .van-ellipsis {
    max-width: var(--dropdownMenuWidth);
  }
}

.dropdown-menu-custom {
  background: white;
  text-align: center;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-bottom: 1px #E8E8E8 solid;
  border-left: 1px #E8E8E8 solid;
  border-right: 1px #E8E8E8 solid;
  padding: 10px 0;

  box-shadow: 1px 1px 1px -1px rgba(0, 0, 0, 0.15);
}

.dropdown-menu-date {
  background: white;
  text-align: center;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-bottom: 1px #E8E8E8 solid;
  border-left: 1px #E8E8E8 solid;
  border-right: 1px #E8E8E8 solid;
  padding: 16px;

  box-shadow: 1px 1px 1px -1px rgba(0, 0, 0, 0.15);
}

.month {
  font-weight: bold;
  font-size: 24px
}

.year {
  font-weight: bold;
  font-size: 24px;
  margin-left: 16px;
}

.day-item {
  font-size: 14px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-top: 21px;
  color: #BDBDBD;
}

.weekend {
  font-size: 14px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 21px;
  font-weight: bold;
  position: relative;
}

.day-select {
  background: #333333 !important;
  color: white !important;
  pointer-events: unset;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.day-active {
  background: white;
  color: #333333;
  width: 30px;
  height: 30px;
  pointer-events: unset;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.day {
  background: white;
  color: #BDBDBD;
  width: 30px;
  height: 30px;
  pointer-events: unset;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}


.cancel-btn {
  width: 99px;
  height: 34px;
  color: #333333;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.apply-btn {
  width: 99px;
  height: 34px;
  background: #333333;
  color: white;
  border-radius: 12px;
  line-height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.disable-next-month {
  color: #e8e8e8;
}


.marquee {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
}

.marquee span {
  display: inline-block;
  animation: marquee 10s linear infinite;
}

@keyframes marquee {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(-100%);
  }
}

.active-color {
  color: red;
}

</style>